import { Component, Inject } from '@angular/core';
import { IdTokenClaims, PromptValue } from '@azure/msal-common';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, InteractionRequiredAuthError, InteractionStatus, InteractionType, RedirectRequest, SsoSilentRequest } from '@azure/msal-browser';
import { b2cPolicies, protectedResources } from './auth-config';
import { filter, map, merge, Subject, Subscription, switchMap, takeUntil, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MenuService } from './pages/layout-component/services/menu.service';
import { AuthModel } from './pages/models/auth.models';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DataService } from './shared-services/cache-data.service';
import { SignalRService } from './shared-services/signalR.service';
declare var $: any;
type IdTokenClaimsWithPolicyId = IdTokenClaims & {
  acr?: string,
  tfp?: string,
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Microsoft identity platform';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  authModel: AuthModel | undefined;
  subscription !: Subscription;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private _titleService: Title,
    private authService: MsalService, public service: MenuService,
    private _cachedService: DataService, private router: Router,
    private _translateService: TranslateService, public _singalRService: SignalRService,
    private msalBroadcastService: MsalBroadcastService, private _router: Router, private _activatedRoute: ActivatedRoute,
    private http: HttpClient, private location: Location
  ) { }


  ngOnInit(): void {

    if (!this.location.path().includes('CPO/page/Add')) { 


      this._translateService.setDefaultLang(environment.defaultLanguage);
      // Listen for error events
      this.msalBroadcastService.msalSubject$
        .pipe(
          tap((msg: any) => {
            const error = msg.error as InteractionRequiredAuthError;
            if (error && error.errorMessage && error.errorMessage.includes('AADB2C90091')) {
              // Redirect: User has cancelled self-asserted or change password.  
              this.authService.instance.loginRedirect();
            }
          //  else if (error && error.errorMessage && error.errorMessage.includes('AADB2C90118')) {
          //    // Trigger the Password Reset user journey
          //    this.authService.loginRedirect({
          //      authority:
          //        environment.b2cPolicies.authorities.resetPassword.authority,
          //      scopes: environment.apiConfig.scopes
          //    });
          //  }
          })
        )
        .subscribe();
      this.msalBroadcastService.msalSubject$
        .pipe(

          filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS
            //|| msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
            || msg.eventType === EventType.SSO_SILENT_SUCCESS),
          takeUntil(this._destroying$)
        )
        .subscribe((result: EventMessage) => {
          let payload = result.payload as AuthenticationResult;
          let idtoken = payload.idTokenClaims as IdTokenClaimsWithPolicyId;
          sessionStorage.setItem('token', payload.accessToken);
          sessionStorage.setItem('username', payload.account != null ? payload.account.username : "");
          if (payload.account?.name != "unknown" && payload.account?.name != "") {
            sessionStorage.setItem('loggedInUserName', payload.account!.name ?? '');
          }
          this.authModel = {
            IsAuthenticated: true,
            RefreshToken: payload.accessToken,
            Token: payload.accessToken,
            ExpiresOn: payload.expiresOn != null ? payload.expiresOn : new Date(),
            RefreshTokenExpiration: payload.expiresOn != null ? payload.expiresOn : new Date()
          }
          sessionStorage.setItem('tokenModel', JSON.stringify(this.authModel));
          if (!sessionStorage.getItem("IsSetToken")) {
            this.SetToken();
          }
        

          if (idtoken.acr === b2cPolicies.names.signUpSignIn || idtoken.tfp === b2cPolicies.names.signUpSignIn) {
            this.authService.instance.setActiveAccount(payload.account);
          }
          scopes: [protectedResources.apiMenueList.scopes.read]

          /**
           * For the purpose of setting an active account for UI update, we want to consider only the auth response resulting
           * from SUSI flow. "acr" claim in the id token tells us the policy (NOTE: newer policies may use the "tfp" claim instead).
           * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
           */
          if (idtoken.acr === b2cPolicies.names.editProfile || idtoken.tfp === b2cPolicies.names.editProfile) {
            // retrieve the account from initial sing-in to the app
            const originalSignInAccount = this.authService.instance.getAllAccounts()
              .find((account: AccountInfo) =>
                account.idTokenClaims?.oid === idtoken.oid
                && account.idTokenClaims?.sub === idtoken.sub
                && ((account.idTokenClaims as IdTokenClaimsWithPolicyId).acr === b2cPolicies.names.signUpSignIn
                  || (account.idTokenClaims as IdTokenClaimsWithPolicyId).tfp === b2cPolicies.names.signUpSignIn)
              );

            let signUpSignInFlowRequest: SsoSilentRequest = {
              authority: b2cPolicies.authorities.signUpSignIn.authority,
              account: originalSignInAccount
            };
            // silently login again with the signUpSignIn policy
            this.authService.ssoSilent(signUpSignInFlowRequest);
          }
          return result;
        });

    }
    this._singalRService.initiateSignalrConnection();
  }
  async SetToken() {
    if (this.authModel != undefined) {
      let result: any = await this.service.SetToken(this.authModel);
      if (result == true) {
        this._cachedService.isTokenSet.next(result);
        sessionStorage.setItem('IsSetToken', 'true');
      }
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewChecked() {
    let url = this.router.url;
    if (url.split('/')[1] && $('.nav nav-link')) {
      $('.nav a.active').removeClass('active');
      $('.submenu_a_' + url.split('/')[1].toLowerCase()).addClass('active');
    }
  }
}
